'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { HtmlRendererRaw } from '@eliadmin/core/src/components/ui/html-renderer-raw';

interface HeadingProps {
  title: string;
  className?: string;
  tag: 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  semanticTag?: 'h1' | 'h2' | 'h3' | 'span';
}

export function Heading({ title, className, tag, semanticTag }: HeadingProps) {
  const Tag = tag;

  return (
    <HtmlRendererRaw
      as={semanticTag ?? Tag}
      data-ea-visual-tag={semanticTag ? tag : undefined}
      className={cn(
        'ea-heading',
        'font-semibold tracking-tighter',
        'leading-[1.2] sm:leading-[1.2] md:leading-[1.2] lg:leading-[1.2] xl:leading-[1.2]',
        `ea-heading--${tag}`,
        className,
      )}
      html={title}
    />
  );
}
